import { View, Text, StyleSheet, Document, Page } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: "Helvetica",
    color: "#333",
  },
  // Top area: Project/Service name + total
  headerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 40, // Increased for more space
  },
  serviceName: {
    fontSize: 16,
    fontWeight: "bold",
  },
  servicePrice: {
    fontSize: 16,
    fontWeight: "bold",
  },

  // Table container with subtle shadow and minHeight
  tableContainer: {
    padding: 10,
    minHeight: 600, // Keep consistent height even if few rows
    marginBottom: 20,
  },

  // Table header
  tableHeader: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    paddingBottom: 6,
    marginBottom: 8,
  },
  headerCellLeft: {
    flex: 3,
    fontWeight: "bold",
    textTransform: "uppercase",
    fontSize: 10,
  },
  headerCell: {
    flex: 1,
    fontWeight: "bold",
    textAlign: "right",
    textTransform: "uppercase",
    fontSize: 10,
  },

  // Table rows
  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#ccc",
    paddingVertical: 22, // Increase for taller rows
  },
  itemCellLeft: {
    flex: 3,
    fontSize: 10,
  },
  itemCell: {
    flex: 1,
    textAlign: "right",
    fontSize: 10,
  },
  itemName: {
    fontWeight: "bold",
    fontSize: 10,
    marginBottom: 3,
  },
  itemDescription: {
    fontSize: 9,
    color: "#666",
    lineHeight: 1.3,
    marginTop: 3,
  },

  // Final total row (only the last column has text)
  totalRow: {
    flexDirection: "row",
    paddingVertical: 12,
    marginTop: 10,
  },

  pageCount: {
    fontSize: 11,
    fontWeight: "500",
    position: "absolute",
    bottom: 15,
    left: "45%",
    textAlign: "center",
  },
  topHeading: {
    flexDirection: "column",
    gap: 10,
    // justifyContent: "space-between",
    // alignItems: "center",
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 10,
  },
});

const topHeder = StyleSheet.create({
  container: {
    border: "1px solid #ccc",
    borderRadius: 5,
    padding: 15,
    display: "flex",
    flexDirection: "row",
    backgroundColor: "#f9f9f9",
  },
  leftBorder: {
    width: 5,
    backgroundColor: "#1976d2", // Blue left border
  },
  content: {
    marginLeft: 10,
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  icon: {
    fontSize: 12,
    marginRight: 5,
    color: "#1976d2", // Blue info icon color
  },
  textContainer: {
    fontSize: 10,
  },
  boldText: {
    fontWeight: "bold",
  },
  regularText: {
    fontWeight: "normal",
  },
});

function ServiceTablePDF({ service, index, count }) {
  const currentPage = index + 1 + 5;
  const totalPage = count + 5 + 1;
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Top heading: name + total */}

        <View style={styles.headerRow}>
          <Text style={styles.serviceName}>{service.name}</Text>
          <Text style={styles.servicePrice}>${service?.price?.toFixed(2)}</Text>
        </View>

        <View style={styles.tableContainer}>
          {/* Table Header */}
          <View style={styles.tableHeader}>
            <Text style={styles.headerCellLeft}>Items</Text>
            <Text style={styles.headerCell}>Qty</Text>
            <Text style={styles.headerCell}>Price</Text>
            <Text style={styles.headerCell}>Total</Text>
          </View>

          {/* Table Rows */}
          {service?.details?.map((item, index) => (
            <View key={index} style={styles.row}>
              <View style={styles.itemCellLeft}>
                <Text style={styles.itemName}>{item.name}</Text>
                {item.description && (
                  <Text style={styles.itemDescription}>{item.description}</Text>
                )}
              </View>
              <Text style={styles.itemCell}>{item.quantity}</Text>
              <Text style={styles.itemCell}>${item.price.toFixed(2)}</Text>
              <Text style={styles.itemCell}>
                ${(item.price * item.quantity).toFixed(2)}
              </Text>
            </View>
          ))}

          {/* Total Row (aligned to the right) */}
          <View style={[styles.totalRow]}>
            {/* Empty columns */}
            <Text style={styles.itemCellLeft}></Text>
            <Text style={styles.itemCell}></Text>
            <Text style={styles.itemCell}></Text>
            {/* Show 'Total' + amount in last column */}
            <Text style={[styles.itemCell, { fontWeight: "bold" }]}>
              Total ${service?.price?.toFixed(2)}
            </Text>
          </View>
        </View>

        {/* <Text style={styles.pageCount}>
          {currentPage} of {totalPage}
        </Text> */}
      </Page>
    </Document>
  );
}

export default ServiceTablePDF;
